import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Timestamp } from 'firebase/firestore';

@Pipe({ name: 'fsTimestamp' })
export class FsTimestampPipe implements PipeTransform {
    constructor(private datePipe: DatePipe) {}

    transform(
        value: any,
        format: string = 'yyyy-MM-dd hh:mm:ss',
        timezone?: string,
        locale?: string
    ): string | null {
        const date = value != null ? (value as Timestamp).toDate() : null;
        return this.datePipe.transform(date, format, timezone, locale);
    }
}
